<template>
  <div id="app">
    <nav><router-link to="/"></router-link></nav>
    <router-view />
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      obj: {},
    };
  },
  computed: {},

  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="less">
body,
html {
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
</style>
